const canonicalURL = "https://mannuelportraits.co.ke";

export default canonicalURL;